var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/compose-button.tsx";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';
import { openModal } from 'soapbox/actions/modals';
import { Button } from 'soapbox/components/ui';

const ComposeButton = () => {
  const dispatch = useDispatch();

  const onOpenCompose = () => dispatch(openModal('COMPOSE'));

  return /*#__PURE__*/React.createElement("div", {
    className: "mt-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 13,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Button, {
    theme: "accent",
    icon: require('@tabler/icons/pencil-plus.svg'),
    block: true,
    size: "lg",
    onClick: onOpenCompose,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement("span", {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "navigation.compose",
    defaultMessage: "Compose",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15,
      columnNumber: 15
    }
  }))));
};

export default ComposeButton;